// Tabs left open across a deploy keep running the old app. Every few minutes (and when the tab regains focus) check
// whether index.html now points at a different bundle, and offer a reload.
import React, { useEffect, useState } from 'react';

const bundle = (html) => (html.match(/\/static\/js\/main\.([a-z0-9]+)\.js/) || [])[1] || null;
const mine = () => bundle(Array.from(document.scripts).map((s) => s.src).join(' '));
const EVERY_MS = 5 * 60 * 1000;

export default function UpdateBanner() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const current = mine();
    if (!current) return undefined;                  // local dev server: nothing to compare
    let last = 0;
    const check = async () => {
      if (Date.now() - last < 60 * 1000) return;     // focus + interval shouldn't double up
      last = Date.now();
      try {
        const r = await fetch('/index.html', { cache: 'no-store' });
        const latest = bundle(await r.text());
        if (latest && latest !== current) setStale(true);
      } catch { /* offline or blocked: try again later */ }
    };
    const t = setInterval(check, EVERY_MS);
    const onFocus = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onFocus); window.addEventListener('focus', onFocus);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onFocus); window.removeEventListener('focus', onFocus); };
  }, []);
  if (!stale) return null;
  return (
    <div role="status" style={{ position: 'fixed', left: '50%', bottom: 18, transform: 'translateX(-50%)', zIndex: 1000, background: '#1E1B4B', color: '#fff',
      borderRadius: 12, padding: '10px 14px', display: 'flex', gap: 12, alignItems: 'center', boxShadow: '0 8px 24px rgba(30,27,75,.25)', fontSize: 13.5, fontFamily: 'Inter, system-ui, -apple-system, sans-serif', maxWidth: 'calc(100vw - 32px)' }}>
      <span>✨ A new version of NinjaEval is available. Your work is saved.</span>
      <button className="ef-btn sm" style={{ background: '#fff', color: '#1E1B4B' }} onClick={() => window.location.reload()}>Reload</button>
      <button type="button" aria-label="Dismiss" onClick={() => setStale(false)} style={{ background: 'none', border: 0, color: '#C7D2FE', cursor: 'pointer', fontSize: 16 }}>✕</button>
    </div>
  );
}
